'use strict';

export default () => {
  'ngInject';

  return (name) => {
    var whiteSpace = name.indexOf(' ');
    if (whiteSpace !== -1) {
      return name.substr(0, whiteSpace);
    } else {
      return name;
    }
  };
};



// WEBPACK FOOTER //
// ./app/src/filters/first_name.js